import { addDays, addMonths } from 'date-fns';
import { useCallback } from 'react';
import type { Mode } from '../../../../types';
import type { ButtonDirection } from '../DateNavigator';

export const useGetShiftedDate = () =>
  useCallback(({ date, direction, mode }: { date: Date; direction: ButtonDirection; mode: Mode }) => {
    if (direction === 'today') {
      return new Date();
    }

    const directionNumber = direction === 'previous' ? -1 : 1;

    switch (mode) {
      case 'day':
        return addDays(date, directionNumber);
      case 'month':
        return addMonths(date, directionNumber);
      case 'week':
        return addDays(date, directionNumber * 7);
    }
  }, []);
